<template>
  <div class="table-group">
    <div class="group-title flex flex-x-between flex-y-center">
      <span>原材料成本</span>
      <div v-if="isChoose && selfList.length && false" class="edit-base-price">
        <span>修改基价：</span>
        <el-input
          v-model="selfList[0].ji_chu_jia_ge"
          type="number"
          size="mini"
          :disabled="disabled"
          @input="calcPrice(selfList[0])"
        >
          <span v-if="basePriceUnit" slot="suffix">元/{{ basePriceUnit }}</span>
        </el-input>
      </div>
    </div>
    <vxe-grid
      ref="xTable"
      :min-height="tableConfig.minHeight"
      :toolbar-config="tableConfig.toolbarConfig"
      :edit-config="tableConfig.editConfig"
      :row-config="tableConfig.rowConfig"
      :mouse-config="tableConfig.mouseConfig"
      :keyboard-config="tableConfig.keyboardConfig"
      :footer-method="tableFooterMethod"
      :columns="tableColumn"
      :data="selfList"
      :show-footer="!!selfList.length"
    >
      <!-- slot_default -->
      <template #default_list_chan_pin_tu="{ row }">
        <e-upload-image
          v-if="row.list_chan_pin_tu"
          :list.sync="row.list_chan_pin_tu"
          :limit="2"
          :disabled="disabled"
          isDelete
        />
      </template>
      <template #default_name="{ row }">
        <div class="flex flex-x-between flex-y-center">
          <el-input
            v-model="row.name"
            size="mini"
            class="flex-1"
            :disabled="disabled"
            @focus="focusName"
            @blur="blurName"
            @input="changeName(row.name)"
          >
            <el-link
              slot="append"
              v-if="!disabled && isChoose"
              type="primary"
              :underline="false"
              @click="chooseShangPin"
            >
              选择原料
            </el-link>
          </el-input>
        </div>
        <div v-if="muBanList.length && isShowFastList" class="fast-list">
          <div
            v-for="(item, index) in muBanList"
            :key="index"
            class="fast-item"
            @click="doShangPin(item)"
          >
            {{ item.mu_ban_ming_cheng }}
          </div>
        </div>
      </template>
      <template #default_list_gong_cheng_tu="{ row }">
        <e-upload-image
          :list.sync="row.list_gong_cheng_tu"
          :limit="2"
          :disabled="disabled"
          isDelete
        />
      </template>
      <template #default_list_yuan_wen_jian="{ row }">
        <e-upload-file :list.sync="row.list_yuan_wen_jian" :disabled="disabled" isDelete />
      </template>
      <template #default_list_jian_ce_mu_ban="{ row }">
        <e-upload-file :list.sync="row.list_jian_ce_mu_ban" :disabled="disabled" isDelete />
      </template>
      <template #default_list_jian_ce_bao_gao="{ row }">
        <e-upload-file :list.sync="row.list_jian_ce_bao_gao" :disabled="disabled" isDelete />
      </template>
      <template #default_jin_du="{ row }">
        <div class="flex">
          <div class="flex flex-y-center" v-for="(item, index) in jin_du_list" :key="index">
            <span v-if="index">-</span>
            <el-link v-if="row.jin_du === index" type="primary">{{ item }}</el-link>
            <el-link v-if="row.jin_du > index" type="success">{{ item }}</el-link>
            <el-link v-if="row.jin_du < index" type="danger">{{ item }}</el-link>
          </div>
        </div>
      </template>

      <!-- slot_edit -->
      <template #edit_spec="{ row }">
        <el-input
          v-model="row.spec"
          type="text"
          size="mini"
          @input="inputUpdate('spec', row); calcPrice(row)"
        />
      </template>
      <template #edit_unit="{ row }">
        <el-input v-model="row.unit" type="text" size="mini" @input="inputUpdate('unit', row)" />
      </template>
      <template #edit_counts="{ row }">
        <el-input
          v-model="row.counts"
          type="number"
          size="mini"
          @input="inputUpdate('counts', row)"
        />
      </template>
      <template #edit_goods_price="{ row }">
        <el-input v-model="row.goods_price" type="number" size="mini" @input="onGoodsPriceInput(row)" />
      </template>
      <template #edit_remark="{ row }">
        <el-input v-model="row.remark" type="text" size="mini" />
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      required: true
    },
    isChoose: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      timer: null,
      isShowFastList: false,
      jin_du_list: ['待采购', '采购中', '已入库'],
      muBanList: [],
      selfList: [],
      productDetail: null,
      basePriceUnit: '',
      calcTimer: null,
      isInitingBasePrice: false
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let disabled = this.disabled
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return !disabled
          }
        },
        keyboardConfig: {
          isEdit: !disabled
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    },
    tableColumn() {
      let result = [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 63
        },
        {
          title: '原料图片',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: '原料名称',
          field: 'name',
          slots: { default: 'default_name' },
          width: 144
        },
        {
          title: '规格(mm)',
          field: 'spec',
          slots: { edit: 'edit_spec' },
          editRender: { autofocus: '.el-input__inner' },
          width: 100
        },
        {
          title: '单位',
          field: 'unit',
          slots: { edit: 'edit_unit' },
          editRender: { autofocus: '.el-input__inner' },
          width: 70
        },
        {
          title: '数量',
          field: 'counts',
          slots: { edit: 'edit_counts' },
          editRender: { autofocus: '.el-input__inner' },
          width: 70
        },
        {
          title: '单价',
          field: 'goods_price',
          slots: { edit: 'edit_goods_price' },
          editRender: { autofocus: '.el-input__inner' },
          width: 80
        },
        {
          title: '金额',
          field: 'goods_amount',
          width: 80
        },
        {
          title: '工程图',
          field: 'list_gong_cheng_tu',
          slots: { default: 'default_list_gong_cheng_tu' },
          width: 63
        },
        {
          title: '源文件',
          field: 'list_yuan_wen_jian',
          slots: { default: 'default_list_yuan_wen_jian' },
          width: 80
        },
        {
          title: '检测模板',
          field: 'list_jian_ce_mu_ban',
          slots: { default: 'default_list_jian_ce_mu_ban' },
          width: 80
        },
        {
          title: '检测报告',
          field: 'list_jian_ce_bao_gao',
          slots: { default: 'default_list_jian_ce_bao_gao' },
          width: 80
        },
        {
          title: '进度',
          field: 'jin_du',
          slots: { default: 'default_jin_du' },
          width: 132
        },
        {
          title: '备注',
          field: 'remark',
          slots: { edit: 'edit_remark' },
          editRender: { autofocus: '.el-input__inner' }
        }
      ]
      if (!this.isChoose) {
        result.forEach((item) => {
          if (item.title === '数量' || item.title === '单价') {
            delete item.editRender
            delete item.slots
          }
        })
      }
      return result
    }
  },
  watch: {
    list: {
      handler(val) {
        if (JSON.stringify(this.selfList) !== JSON.stringify(val)) {
          this.selfList = this.$util.deepCopy(val)
          this.selfList.forEach((row) => {
            if (!Object.prototype.hasOwnProperty.call(row, 'ji_chu_jia_ge')) {
              this.$set(row, 'ji_chu_jia_ge', '')
            }
          })
          // this.initBasePrice()
        }
      },
      deep: true,
      immediate: true
    },
    selfList: {
      handler(val) {
        if (JSON.stringify(this.list) !== JSON.stringify(val)) {
          this.$emit('update:list', this.$util.deepCopy(val))
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 名称输入框-获取焦点时，显示模板列表
    focusName() {
      this.isShowFastList = true
      this.getMuBanListData(this.selfList[0].name)
    },
    // 名称输入框-失去焦点时，隐藏模板列表
    blurName() {
      setTimeout(() => {
        this.isShowFastList = false
      }, 300)
    },
    // 名称改变时，更新模板列表
    changeName(name) {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.getMuBanListData(name)
        this.timer = null
      }, 300)
    },
    // 获取模板列表数据
    async getMuBanListData(name) {
      await this.$api({
        method: 'post',
        url: '/admin/gcvip/muBan/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          bao_han: ['原料'], // '原料', '零件', '组装'
          sortData: {
            id: 'desc'
          },
          filterData: {
            mu_ban_ming_cheng: name
          }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.muBanList = res.data.page.list
          }
        })
        .catch(() => {})
    },
    // 选择商品
    chooseShangPin() {
      this.$emit('chooseShangPin')
    },
    // 新增商品
    doShangPin(item) {
      this.isShowFastList = false
      this.$emit('doShangPin', item)
    },
    // 表格底部
    tableFooterMethod({ columns, data }) {
      // 重新计算行金额，修复金额合计不是最新结果的问题
      data.forEach((item) => {
        let a = Number(item.goods_price)
        let b = Number(item.counts)
        item.goods_amount = this.$XEUtils.multiply(a, b)
      })
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['counts', 'goods_price', 'goods_amount'].includes(column.field)) {
            return this.$tool.listAddTotal(data, column.field)
          }
        })
      ]
    },
    // 初始化基价
    async initBasePrice() {
      let row = this.selfList[0]
      if (!row || !row.bind_id || row.ji_chu_jia_ge || this.isInitingBasePrice) return
      this.isInitingBasePrice = true
      let detail = await this.getProductDetail(row.bind_id)
      if (detail && !row.ji_chu_jia_ge) {
        this.$set(row, 'ji_chu_jia_ge', detail.ji_chu_jia_ge || '')
        // 基价设置后，如果规格和单位都有值，触发单价计算
        if (row.ji_chu_jia_ge && row.spec && row.unit) {
          this.doCalcPrice(row)
        }
      }
      this.isInitingBasePrice = false
    },
    // 获取商品详情
    async getProductDetail(id) {
      if (this.productDetail && this.productDetail.id === id) {
        return this.productDetail
      }
      let result = null
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/products/detail',
        params: {
          id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            result = this.$util.deepCopy(res.data.data)
            this.productDetail = result
            // 设置基价单位（默认单位组的主单位）
            this.basePriceUnit = result.mo_ren_dan_wei_zu
              ? result.mo_ren_dan_wei_zu.split(',')[0]
              : ''
          }
        })
        .catch(() => {})
      return result
    },
    // 计算单价和金额
    calcPrice(row) {
      if (!row.bind_id || !row.spec || !row.unit) return
      if (this.calcTimer) clearTimeout(this.calcTimer)
      this.calcTimer = setTimeout(() => {
        this.doCalcPrice(row)
        this.calcTimer = null
      }, 300)
    },
    // 确认计算单价和金额
    async doCalcPrice(row) {
      if (!row.bind_id || !row.spec || !row.ji_chu_jia_ge || !row.unit) return
      let detail = await this.getProductDetail(row.bind_id)
      if (!detail) return

      // 确保附加参数示例存在
      if (!Array.isArray(detail.fu_jia_can_shu_shi_li)) {
        detail.fu_jia_can_shu_shi_li = []
      }
      let fuJiaList = detail.fu_jia_can_shu_list || []
      detail.fu_jia_can_shu_shi_li = fuJiaList.map((item, index) => {
        return detail.fu_jia_can_shu_shi_li[index] || item.value || ''
      })

      let verifyData = {
        gui_ge_shi_li: row.spec,
        ji_chu_jia_ge: row.ji_chu_jia_ge,
        ji_chu_chan_liang: detail.ji_chu_chan_liang || 1,
        ji_jia_shi_li: '',
        chan_liang_shi_li: ''
      }

      this.$tool.actionVerify(verifyData, detail)

      // 查找匹配单位的单价
      let price = ''
      let danWeiZuList = detail.dan_wei_zu_list || []
      danWeiZuList.forEach((itemSt) => {
        itemSt.dan_wei_list.forEach((itemNd) => {
          let mergeName = `${itemNd.dan_wei_name},${itemSt.dan_wei_zu_name}`
          if (mergeName === row.unit || itemNd.dan_wei_name === row.unit) {
            price = itemNd.verify_price_val
          }
        })
      })

      if (price !== '' && price !== undefined && price !== null) {
        row.goods_price = this.$util.getNumberFullString(price)
        row.goods_amount = this.$XEUtils.multiply(Number(row.goods_price), Number(row.counts))
        // 强制更新表格底部汇总
        this.$nextTick(() => {
          if (this.$refs.xTable) {
            this.$refs.xTable.updateFooter()
          }
        })
        // 通知父组件基价计算完成，需要级联更新
        this.$emit('calcComplete', {
          goods_price: row.goods_price,
          goods_amount: row.goods_amount,
          counts: row.counts,
          spec: row.spec,
          unit: row.unit
        })
      }
    },
    inputUpdate(field, row) {
      let obj = {
        idx: 1,
        key: field,
        val: row[field]
      }
      this.$emit('fieldUpdate', this.$util.deepCopy(obj))
      // counts变化时重算金额并通知父组件级联
      if (field === 'counts') {
        row.goods_amount = this.$XEUtils.multiply(Number(row.goods_price), Number(row.counts))
        this.$emit('calcComplete', {
          goods_price: row.goods_price,
          goods_amount: row.goods_amount,
          counts: row.counts,
          spec: row.spec,
          unit: row.unit
        })
      }
    },
    // 手动修改原材料单价时，重算金额并通知父组件更新零件
    onGoodsPriceInput(row) {
      row.goods_amount = this.$XEUtils.multiply(Number(row.goods_price), Number(row.counts))
      // 延迟发出级联事件，等待 selfList watcher 同步完成，避免父组件回写导致输入框失焦
      this.$nextTick(() => {
        this.$emit('rawPriceChange', {
          goods_price: row.goods_price,
          goods_amount: row.goods_amount,
          counts: row.counts
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table-group {
  margin-bottom: 15px;
  .group-title {
    .edit-base-price {
      display: flex;
      align-items: center;
      span {
        font-size: 12px;
      }
      /deep/ .el-input {
        width: 120px;
      }
    }
  }
  .fast-list {
    position: absolute;
    top: 29px;
    left: 2px;
    width: 138px;
    max-height: 226px;
    overflow-y: auto;
    .scroll-bar();
    background: @colorWhite;
    border: @border;
    z-index: 99;
    .fast-item {
      padding: 0 5px;
      line-height: 28px;
      cursor: pointer;
      &:hover {
        background: @colorBlue20;
      }
    }
  }
}
</style>
